import React from 'react'

let vector = [0]

const Footer = function footer ({info}){
    const handleWhatsappClick = (e) => {
        e.preventDefault();
        const whatsappUrl = `https://api.whatsapp.com/send/?phone=${info.whatsapp}&text=Hola, me gustaria cotizar productos sobre su portafolio`;
        window.open(whatsappUrl, '_blank');
        gtag_report_conversion(whatsappUrl);
    };
    return (
        <div>
            <a href={"https://api.whatsapp.com/send/?phone="+info.whatsapp+'&text=Hola, me gustaria cotizar productos sobre su portafolio'} className="floatWpp grid flex" target='_blank' onClick={handleWhatsappClick}>
                <img src="/img/wpp.svg" alt="🌐"/>
            </a>
            <footer>
                <div className="container colflex">
                    <img src="/img/logow.svg" alt="logo-white" className="logoFoo"/>
                    <div className="item colflex">
                        <h3>llámanos</h3>
                        <a href={'tel:'+info.phone_one} target='_blank'>{info.phone_one}</a>
                        <a href={'tel:'+info.phone_two} target='_blank'>{info.phone_two}</a>
                        <a href={'tel:'+info.phone_three} target='_blank'>{info.phone_three}</a>
                        <a href={'tel:573103639168'} target='_blank'>(+57) 3103639168</a>
                        <h3>Escríbenos</h3>
                        <a  href={'mailto:'+info.mail_one} target='_blank'>{info.mail_one}</a>
                        <a  href={'mailto:'+info.mail_two} target='_blank'>{info.mail_two}</a>
                    </div>
                    <div className="item colflex">
                        <h3>encuéntranos</h3>
                        <p>{info.address}, {info.city}</p>
                        <h3>Síguenos</h3>
                        <div className="social flex">
                            <a href={info.instagram} target="_blank" className="flex">
                                <img src="/img/insta.svg" alt="Ig-icon"/>
                            </a>
                            <a href={info.facebook} target="_blank" className="flex">
                                <img src="/img/face.svg" alt="Fb-icon"/>
                            </a>
                            </div>
                    </div>
                    <div className="qrInfo colflex">
                        <div className="qr dnone">
                            <p>
                                Escanea el QR<br/>y descarga<br/>nuestro Brochure
                            </p>
                            <img src={"/"+info.qr_brochure} alt="qr-image"/>
                        </div>
                        <div className="brochure colflex">
                            <p>Descarga nuestro Brochure</p>
                            <a href={"/"+info.brochure} target='_blank' className="flex">
                                <img src="/img/down.svg" alt="⬇️"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="gtnd colflex">
                    <p>
                        Radio Comunicaciones Del Caribe. <br/>Todos los derechos <br/>reservados
                    </p>
                    <span>|</span>
                    <div className="mark colflex">
                        <p>Creado por</p>
                        <a href="https://gutand.com/" target='_blank' className="flex">
                            <img src="/img/gtnd.svg" alt="Gutand"/>        
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer